import { render, staticRenderFns } from "./BaseItemGroup.vue?vue&type=template&id=c6dcbe28"
import script from "./BaseItemGroup.vue?vue&type=script&lang=js"
export * from "./BaseItemGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports